import store from './lib/styles/store';

var needCss = function needCss(mod) {
  return store.mods[mod] = 1;
};

export default needCss;